import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/users-plus.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M1 21C1 20.0818 0.999119 19.3429 1.04004 18.7432C1.08157 18.1345 1.16981 17.5965 1.38086 17.0869C1.88833 15.8618 2.86178 14.8883 4.08692 14.3809C4.59653 14.1698 5.13455 14.0816 5.74317 14.04C6.34293 13.9991 7.0818 14 8 14H12C12.5523 14 13 14.4477 13 15C13 15.5523 12.5523 16 12 16H8C7.05468 16 6.39572 16.001 5.87988 16.0361C5.37297 16.0707 5.07695 16.1352 4.85156 16.2285C4.11679 16.533 3.53299 17.1168 3.22852 17.8516C3.13516 18.0769 3.07072 18.373 3.03613 18.8799C3.00096 19.3957 3 20.0547 3 21C3 21.5523 2.55229 22 2 22C1.44772 22 1 21.5523 1 21ZM18 21V19H16C15.4477 19 15 18.5523 15 18C15 17.4477 15.4477 17 16 17H18V15C18 14.4477 18.4477 14 19 14C19.5523 14 20 14.4477 20 15V17H22C22.5523 17 23 17.4477 23 18C23 18.5523 22.5523 19 22 19H20V21C20 21.5523 19.5523 22 19 22C18.4477 22 18 21.5523 18 21ZM12.5 7C12.5 5.34315 11.1569 4 9.5 4C7.84315 4 6.5 5.34315 6.5 7C6.5 8.65685 7.84315 10 9.5 10C11.1569 10 12.5 8.65685 12.5 7ZM17 7C17 5.82109 16.3197 4.79904 15.3272 4.30859L15.125 4.21777L15.0322 4.1748C14.5839 3.93828 14.3792 3.39598 14.5732 2.91602C14.7805 2.40409 15.3631 2.15706 15.875 2.36426C17.7056 3.10525 19 4.90006 19 7C19 9.09994 17.7056 10.8948 15.875 11.6357C15.3631 11.8429 14.7805 11.5959 14.5732 11.084C14.3663 10.5721 14.6132 9.98941 15.125 9.78223C16.2262 9.33639 17 8.25736 17 7ZM14.5 7C14.5 9.76142 12.2614 12 9.5 12C6.73858 12 4.5 9.76142 4.5 7C4.5 4.23858 6.73858 2 9.5 2C12.2614 2 14.5 4.23858 14.5 7Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as UsersPlusIcon };
